import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from "../router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function homeClicked() {
  router.push("/");
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_component_font_awesome_icon, {
    icon: ['fas', 'home'],
    size: "2x",
    onClick: homeClicked
  }))
}
}

})